//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QRCode from 'qrcode';
import { serialize } from '~/utils/helpers';
import { env } from '~/env';

export default {
  name: 'BlokAppsDeepDownload',
  props: {
    blok: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isVisibleAos: false,
      shortLink: '',
      qrCodeSrc: '',
    }
  },
  computed: {
    aosAnimate() {
      return this.isVisibleAos ? 'aos-animate' : null;
    },
    heading() {
      switch(this.index) {
        case 0:
          return 'h1';
        default:
          return 'h2';
      }
    },
    subHeading() {
      switch(this.parentIndex) {
        case 0:
          return 'h2';
        default:
          return 'h3';
      }
    },
    lazyStrategy() {
      if (this.parentIndex === 0) {
        return {
          'data-not-lazy': '',
        };
      }

      return null;
    },
    appLink() {
      return {
        id: '',
        url: this.shortLink,
        target: '_blank',
        linktype: 'url',
        fieldtype: 'multilink',
        cached_url: this.shortLink
      };
    },
  },
  methods: {
    aosVisibilityChanged(isVisible) {
      this.isVisibleAos = isVisible;
    },
    async getShortLink() {
      const { carNumber, packId, ref, partner } = this.$route.query;
      const getDeepParams = serialize({ carNumber, packId, ref, partner });
      const deepQuery = getDeepParams ? `?${getDeepParams}` : '';
      const { BASE_URL, ANDROID_PACKAGE_NAME, IOS_BUNDLE_ID } = env;

      try {
        const { shortLink } = await this.$axios.$post('https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyBP28vR38WVabMH8DdoZcy8gN-L7Dm1GQo', {
          dynamicLinkInfo: {
            domainUriPrefix: 'https://easypeasy.page.link',
            link: `${BASE_URL}/${deepQuery}`,
            androidInfo: {
              androidPackageName: ANDROID_PACKAGE_NAME
            },
            iosInfo: {
              iosBundleId: IOS_BUNDLE_ID,
              iosAppStoreId: "1540129246",
            }
          }
        });

        return shortLink;
      } catch (err) {
        console.error(err);

        return '';
      }
    },
    async getQrCode(value) {
      try {
        const result = await QRCode.toDataURL(value, {
          errorCorrectionLevel: 'H',
          margin: 0,
          // width: 112,
        });

        return result;
      } catch (err) {
        console.error(err);

        return '';
      }
    },
  },
  async fetch() {
    this.shortLink = await this.getShortLink();
    this.qrCodeSrc = await this.getQrCode(this.shortLink);
  },
}
